import { checkSearchObject } from "app/common/LocalFunction";
import { Building } from "app/common/Model/Building";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  pagingBuilding,
  getBuildingById,
  saveBuilding,
  deleteBuildingById
} from "app/services/BuildingService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class BuildingStore {
  searchBuilding = new SearchObject();
  pageBuilding = null;
  selectedBuilding = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteBuilding = false;
  recentlyUpdated = false;
  pageIndex = 1
  pageSize = 10
  listAllBuildings = []

  constructor() {
    makeAutoObservable(this);
  }

  pagingBuilding = () => {
    pagingBuilding(this.pageIndex, this.pageSize).then(
      ({ data }) => (this.pageBuilding = data)
    );
  };

  getAllBuilding = async () => {
    if (!this.listAllBuildings?.length || this.recentlyUpdated) {
      try {
        const { data } = await pagingBuilding(1, 1000);
        if (data?.content) {
          this.listAllBuildings = data.content;
        } else {
          this.listAllBuildings = [];
        }
      } catch (error) {
        console.error("Error fetching buildings:", error);
        this.listAllBuildings = [];
      }
    }
  };


  handleChangeSearchForm = (searchObject) => {
    searchObject?.pageIndex ? this.pageIndex = searchObject?.pageIndex : this.pageSize = searchObject?.pageSize

    this.pagingBuilding();
  };

  handleOpenFormCreateOrEdit = async (buildingId) => {
    if (Boolean(buildingId)) {
      try {
        const { data } = await getBuildingById(buildingId);
        if (data) {
          this.selectedBuilding = data;
          this.openFormCreateOrEdit = true;
        }
      } catch {
        toast.error("Lấy dữ liệu có lỗi!");
      }
    } else {
      this.selectedBuilding = new Building();
      this.openFormCreateOrEdit = true;
    }
  };

  saveBuilding = async (building, { setSubmitting }) => {
    try {
      await saveBuilding(building);
      this.selectedBuilding = null;
      this.pagingBuilding();
      this.handleClosePopup();
      this.recentlyUpdated = true;

      toast.success("Lưu cơ sở thành công!");
    } catch {
      toast.error("Lưu cơ sở thất bại!");
    } finally {
      setSubmitting(false);
    }
  };

  handleConfirmDeleteBuilding = async () => {
    try {
      await deleteBuildingById(this.selectedBuilding?.id);
      if (
        this.searchBuilding?.pageIndex > 1 &&
        this.pageBuilding?.content?.length === 1
      ) {
        this.searchBuilding.pageIndex -= 1;
      }
      this.pagingBuilding();
      this.recentlyUpdated = true;
      this.handleClosePopup();

      toast.success("Xóa cơ sở thành công!");
    } catch (error) {
      toast.error("Xóa cơ sở thất bại!");
    }
  };

  handleDeleteBuilding = (buildingId) => {
    this.selectedBuilding = { id: buildingId ?? "" };
    this.openConfirmDeleteBuilding = true;
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteBuilding = false;
  };

  resetStore = () => {
    this.searchBuilding = new SearchObject();
    this.pageBuilding = null;
    this.selectedBuilding = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteBuilding = false;
    this.listAllBuildings = []
  };
}
